/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intake_Why_Weight_ShortInputs */

const en_us2_intake_why_weight_short = /** @type {(inputs: Intake_Why_Weight_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The first loads start here`)
};

const pt_br2_intake_why_weight_short = /** @type {(inputs: Intake_Why_Weight_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As primeiras cargas começam aqui`)
};

const es_419_intake_why_weight_short = /** @type {(inputs: Intake_Why_Weight_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las primeras cargas empiezan aquí`)
};

const pt_pt2_intake_why_weight_short = /** @type {(inputs: Intake_Why_Weight_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As primeiras cargas começam aqui`)
};

const fr_fr2_intake_why_weight_short = /** @type {(inputs: Intake_Why_Weight_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les premières charges partent de là`)
};

const de_de2_intake_why_weight_short = /** @type {(inputs: Intake_Why_Weight_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hier starten die ersten Gewichte`)
};

const it_it2_intake_why_weight_short = /** @type {(inputs: Intake_Why_Weight_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I primi carichi partono da qui`)
};

/**
* | output |
* | --- |
* | "The first loads start here" |
*
* @param {Intake_Why_Weight_ShortInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const intake_why_weight_short = /** @type {((inputs?: Intake_Why_Weight_ShortInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intake_Why_Weight_ShortInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_intake_why_weight_short(inputs)
	if (locale === "es-419") return es_419_intake_why_weight_short(inputs)
	if (locale === "pt-PT") return pt_pt2_intake_why_weight_short(inputs)
	if (locale === "fr-FR") return fr_fr2_intake_why_weight_short(inputs)
	if (locale === "de-DE") return de_de2_intake_why_weight_short(inputs)
	if (locale === "it-IT") return it_it2_intake_why_weight_short(inputs)
	return en_us2_intake_why_weight_short(inputs)
});
export { intake_why_weight_short as "intake.why.weight.short" }